// extracted by mini-css-extract-plugin
export default {"root":"Button__root--QOm7p"};